export enum AidFrontendFeatureGate {
  // Stable test-only entry. Use this in unit tests so they don't break when real gates are added or removed.
  TEST_GATE = 'test_gate',
  // https://switcheroo.atlassian.com/ui/gates/c2e09b58-639a-4260-89de-4b390ac2b746/key/identity-aid-frontend-sms-enrollment-new-captcha
  // https://hello.atlassian.net/wiki/spaces/I/pages/4492639544/22-11-2025+Current+State+of+UniCAPTCHA+rollout
  SMS_ENROLLMENT_UNICAPTCHA = 'identity-aid-frontend-sms-enrollment-new-captcha',
  // https://switcheroo.atlassian.com/ui/gates/e2f249e8-68ad-46fe-8617-c903b90bf375/key/kirby-7873_new_json_endpoint_for_verify-email
  ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL = 'kirby-7873_new_json_endpoint_for_verify-email',
  // https://switcheroo.atlassian.com/ui/gates/3148cf7f-c879-41e7-adb9-ddc0d8f3a80b/key/id-frontend_enable_host_headers_for_aws_captcha
  ENABLE_HOST_HEADERS_FOR_AWS_CAPTCHA = 'id-frontend_enable_host_headers_for_aws_captcha',
  // https://switcheroo.atlassian.com/ui/gates/a1c8916e-8cce-4085-ad6d-c308715ff35f/key/identity_id-frontend_aws_captcha_feature
  ENABLE_AWS_WAF_CAPTCHA = 'identity_id-frontend_aws_captcha_feature',
  LAD_14_USE_LOOM_ANONYMOUS_ID = 'lad-14-use-loom-anonymous-id',
  // https://switcheroo.atlassian.com/ui/gates/00200506-55d0-4d30-9965-e83717c0cb86/key/ghost_advanced_cobranding_email_query_param
  GHOST_ADVANCED_COBRANDING_EMAIL_QUERY_PARAM = 'ghost_advanced_cobranding_email_query_param',
  // https://switcheroo.atlassian.com/ui/gates/8cf24e55-9c59-484a-8352-96f6460d32cd/key/id-frontend_enable_base_login_v2_check_username
  ENABLE_BASE_LOGIN_CHECK_USERNAME_V2 = 'id-frontend_enable_base_login_v2_check_username',
}

export enum AidFrontendExperiment {
  // Stable test-only entry. Use this in unit tests so they don't break when real experiments are added or removed.
  TEST_EXPERIMENT = 'test_experiment',
  // https://switcheroo.atlassian.com/ui/gates/f66cdd60-6c9c-4aec-be86-9fdbe0773fd7/key/gwp-9785-servco-lofi-background-signup
  GWP_9785_SERVCO_LOFI_SIGNUP = 'gwp-9785-servco-lofi-background-signup',
  // https://switcheroo.atlassian.com/ui/gates/1170e6b0-6a4e-4c57-bfbf-78b0e65bf2c5/key/electric_identity_anonymous_aa_experiment
  ELECTRIC_IDENTITY_ANONYMOUS_AA_EXPERIMENT = 'electric_identity_anonymous_aa_experiment',
}
